$(document).ready(function () {
  $(".product-slider-bottom-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    fade: true,
    dots: false,
    arrows: false,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><i class="ri-arrow-left-s-line"></i></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next"><i class="ri-arrow-right-s-line"></i></button>',
    asNavFor: ".product-slider-bottom-nav",
  });
  $(".product-slider-bottom-nav").slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: ".product-slider-bottom-for",
    focusOnSelect: true,
    infinite: false,
    draggable: true,
    swipeToSlide: true,
    dots: false,
    arrows: false,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><i class="ri-arrow-left-s-line"></i></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next"><i class="ri-arrow-right-s-line"></i></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });

    $(".product-slider-left-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><i class="ri-arrow-left-s-line"></i></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next"><i class="ri-arrow-right-s-line"></i></button>',
    infinite: false,
    fade: true,
    asNavFor: ".product-slider-left-nav",
  });
  $(".product-slider-left-nav").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    asNavFor: ".product-slider-left-for",
    focusOnSelect: true,
    infinite: false,
    draggable: true,
    swipeToSlide: true,
    verticalSwiping: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
        },
      },
    ],
  });

  $(".product-slider-right-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    loop: true,
    infinite: false,
    fade: true,
    asNavFor: ".product-slider-right-nav",
  });
  $(".product-slider-right-nav").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    asNavFor: ".product-slider-right-for",
    focusOnSelect: true,
    loop: true,
    infinite: true,
    draggable: true,
    swipeToSlide: true,
    verticalSwiping: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".product-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    loop: false,
    fade: true,
  });
});
